<span class="loader"></span>
<div id="loading-text">{{ loadingText }}</div>
